"use client";
 
import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
 
import "./Header.css";
 
// A menu entry is either a plain link, or a link that itself opens a
// nested flyout/accordion submenu (e.g. "Global Presence" under About,
// or "Enterprise Transformation" under What We Do).
type MenuLeaf = string | { label: string; href: string };
type MenuEntry = MenuLeaf | { label: string; href: string; items: MenuLeaf[] };
 
const navItems: { label: string; href: string; menu?: MenuEntry[] }[] = [
  {
    label: "What We Do",
    href: "/whatwedo",
    menu: [
      {
        label: "Enterprise Transformation",
        href: "/enterprise-transformation",
        items: [
          { label: "SAP S/4HANA", href: "/enterprise-transformation/sap-s4hana" },
          { label: "Upgrades & Migrations", href: "/enterprise-transformation/upgrades-migrations" },
          { label: "RISE / GROW", href: "/enterprise-transformation/rise-grow" },
          { label: "SuccessFactors", href: "/enterprise-transformation/successfactors" },
          { label: "BTP & Integration", href: "/enterprise-transformation/sap-btp-integration" },
          { label: "Cloud", href: "/enterprise-transformation/cloud" },
          { label: "Digital Engineering", href: "/enterprise-transformation/digital-engineering" },
        ],
      },
      {
        label: "Data & SAP BDC",
        href: "/datasap",
        items: [
          { label: "Enterprise Data", href: "/datasap/enterprise-data" },
          { label: "Business Semantics", href: "/datasap/business-semantics" },
          { label: "Data Products", href: "/datasap/data-products" },
          { label: "Analytics", href: "/datasap/analytics" },
          { label: "AI-ready Enterprise Data", href: "/datasap/ai-ready-enterprise-data" },
        ],
      },
      {
        label: "AI & Intelligence",
        href: "/whatwedo/Ai-and-Intelligence",
        items: [
          { label: "Enterprise AI", href: "/whatwedo/Ai-and-Intelligence/enterprise-ai" },
          { label: "Machine Learning", href: "/whatwedo/Ai-and-Intelligence/machine-learning" },
          { label: "Predictive Intelligence", href: "/whatwedo/Ai-and-Intelligence/predictive-intelligence" },
          { label: "Decision Intelligence", href: "/whatwedo/Ai-and-Intelligence/decision-intelligence" },
          { label: "AI Agents", href: "/whatwedo/Ai-and-Intelligence/ai-agent" },
        ],
      },
      {
        label: "Operate & Improve",
        href: "/Operate",
        items: [
          { label: "Managed Services", href: "/Operate/managed-services" },
          { label: "ITSM", href: "/Operate/itsm" },
          { label: "Cybersecurity", href: "/Operate/cyber" },
          { label: "Audit & Assurance", href: "/Operate/audit" },
          { label: "Controls & Compliance", href: "/Operate/controls-compliance" },
          { label: "Continuous Improvement", href: "/Operate/continuous-improvement" },
        ],
      },
    ],
  },
  {
    label: "Knowledge",
 
href: "/knowledge",
menu: [
  { label: "Supply Chain & Assets", href: "/knowledge/supply-chain" },
 
  { label: "Finance & Performance", href: "/knowledge/finance-performance" },
 
  { label:"Customer & Revenue" , href:"/knowledge/customer&revenue"},
 
  { label: "Vendor Spend", href: "/knowledge/vendor-spend" },
 
  { label: "Tax, Disclosure & Compliance", href: "/knowledge/tax-disclouser" },
 
  { label: "People & Talent Intelligence", href: "/knowledge/talent-intelligence" },
 
  { label: "Office of CXO", href: "/knowledge/cxo" },
],
  },
  {
    label: "Industries",
    href: "/industries",
    menu: [
      { label: "Energy & Utilities", href: "/industries/energy-utilities" },
      { label: "FMCG & Retail", href: "/industries/fmcg-retail" },
      { label: "Fashion & Lifestyle", href: "/industries/fashion-lifestyle" },
      { label: "Manufacturing", href: "/industries/manufacturing" },
      { label: "Pharma & Life Sciences", href: "/industries/pharma-lifescience" },
      { label: "Hotels & Hospitality", href: "/industries/industry-hotel" },
      { label: "BFSI", href: "/industries/bfsi" },
      { label: "Airlines & Airports", href: "/industries/airlines-airports" },
      { label: "Professional Services", href: "/industries/professional-services" },
    ],
  },
  {
    label: "52 Problems",
    href: "/52problem",
    
    menu: [
      {label: "Explore by Business Area",  href: "/52problem#explore-by-business-area"},
      // "Explore by Industry"
    ],
  },
  {
    label: "Solutions",
    href: "/solutions",
    menu: [
      {label: "Inventory Intelligence" , href: "/solutions/inventory-intelligence"},
      {label: "Cash & Working Capital" , href: "/solutions/cash-working-capital"},
      {label: "Margin & Profitability" , href: "/solutions/margin"},
      {label: "Spend & Vendor", href: "/solutions/spend-ventor"},
      {label:  "Asset & Spare Intelligence" , href: "/solutions/asset-intelligence"},
      {label: "Customer & Revenue" , href: "/solutions/customer"},
      {label: "CXO Intelligence" , href: "/solutions/cxo-intelligence"},    
      {label: "People Intelligence" , href: "/solutions/people-intelligence"},
    ],
  },
  {
    label: "Customers",
    href: "/customers",
     menu: [
  {label : "Customer-Stories" , href: "/customers/Customer-Stories"},
     ]
    },
  {
    label: "Insights",
    href: "/insights",
    menu: [
      {label: "The Week at Orane" , href: "/insights/week-at-orane"},
      {label: "Enterprise AI Intelligence", href:"/insights/enterprise-ai-intelligence"},
      {label: "Industry Perspectives", href:"/insights/industry-perspectives"},
      {label: "Business Knowledge", href:"/insights/business-knowledge"},
      { label: "Playbooks & Downloads", href: "/insights/playbooks-downloads" },
    ],
  },
  {
    label: "About",
    href: "/about",
    menu: [
      { label: "Our Story", href: "/about/our-story" },
      { label: "Leadership", href: "/about/leadership" },
      { label: "Our People", href: "/about/our-people" },
      {
        label: "Global Presence",
        href: "/about/global-presense",
        // items: [
        //   { label: "India", href: "/coming-soon" },
        //   { label: "Africa", href: "/coming-soon" },
        //   { label: "Middle East", href: "/coming-soon" },
        //   { label: "Global Markets", href: "/coming-soon" },
        // ],
      },
      { label: "Partnerships & Alliances", href: "/about/partnership" },
      { label: "Quality & Compliance", href: "/about/quality-compliance" },
      { label: "Responsible Business", href: "/about/responsible-business" },
      { label: "Careers", href: "/careers" },
    ],
  },
];
 
// Helpers — a leaf is just a label/href; an entry may additionally carry
// its own nested `items`.
const leafLabel = (link: MenuLeaf) => (typeof link === "string" ? link : link.label);
const leafHref = (link: MenuLeaf) => (typeof link === "string" ? "/coming-soon" : link.href);
const hasChildren = (entry: MenuEntry): entry is Extract<MenuEntry, { items: MenuLeaf[] }> =>
  typeof entry !== "string" && "items" in entry;
 
export default function Header() {
  const pathname = usePathname();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null);
  const [openNested, setOpenNested] = useState<string | null>(null);
  const [prevPathname, setPrevPathname] = useState(pathname);
 
  if (pathname !== prevPathname) {
    setPrevPathname(pathname);
    setMobileOpen(false);
    setOpenSubmenu(null);
    setOpenNested(null);
  }
 
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);
 
  // Hide the public site header on the admin dashboard.
  if (pathname?.startsWith("/admin")) {
    return null;
  }
 
  return (
    <header className="site-header">
      <div className="header-inner">
        <Link href="/" className="brand" aria-label="Orane Consulting home">
          <Image src="/assets/images/logo.png" alt="Orane Consulting" className="brand-logo" width={162} height={40} style={{ height: "auto" }} priority />
          <span className="brand-tagline">Real Business. Real Problems. Real Value.</span>
        </Link>
 
        <nav className="desktop-nav" aria-label="Main navigation">
          {navItems.map((item) => (
            <div className={`nav-item${item.menu ? " has-menu" : ""}`} key={item.label}>
              <Link
                href={item.href}
                className={
                  [pathname === item.href ? "nav-active" : "", item.menu ? "has-children" : ""]
                    .filter(Boolean)
                    .join(" ") || undefined
                }
              >
                {item.label}
                {item.menu && <span className="nav-chevron">⌄</span>}
              </Link>
 
              {item.menu && (
                <div className="nav-dropdown">
                  <ul>
                    {item.menu.map((entry) => {
                      if (hasChildren(entry)) {
                        return (
                          <li className="has-submenu" key={entry.label}>
                            <Link href={entry.href}>
                              {entry.label}
                              <span className="nav-submenu-arrow">›</span>
                            </Link>
                            <ul className="nav-submenu">
                              {entry.items.map((link) => (
                                <li key={leafLabel(link)}>
                                  <Link href={leafHref(link)}>{leafLabel(link)}</Link>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      }
                      return (
                        <li key={leafLabel(entry)}>
                          <Link href={leafHref(entry)}>{leafLabel(entry)}</Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </nav>
 
        <div className="header-actions">
          <Link href="/tellusyourproblem" className="header-cta">
            Tell Us Your Problem <span>→</span>
          </Link>
          <button
            className="mobile-menu"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((open) => !open)}
          >
            {mobileOpen ? "✕" : "☰"}
          </button>
        </div>
      </div>
 
      <div className={`mobile-nav${mobileOpen ? " is-open" : ""}`}>
        <nav className="mobile-nav-list" aria-label="Mobile navigation">
          {navItems.map((item) => (
            <div className="mobile-nav-item" key={item.label}>
              <div className="mobile-nav-item-row">
                <Link
                  href={item.href}
                  className={item.menu ? "has-children" : undefined}
                  onClick={() => setMobileOpen(false)}
                >
                  {item.label}
                </Link>
                {item.menu && (
                  <button
                    type="button"
                    className={`mobile-nav-toggle${openSubmenu === item.label ? " is-open" : ""}`}
                    aria-label={`${openSubmenu === item.label ? "Collapse" : "Expand"} ${item.label} submenu`}
                    aria-expanded={openSubmenu === item.label}
                    onClick={() =>
                      setOpenSubmenu((current) => (current === item.label ? null : item.label))
                    }
                  >
                    ⌄
                  </button>
                )}
              </div>
 
              {item.menu && (
                <ul className={`mobile-nav-submenu${openSubmenu === item.label ? " is-open" : ""}`}>
                  {item.menu.map((entry) => {
                    if (hasChildren(entry)) {
                      const nestedKey = `${item.label}::${entry.label}`;
                      return (
                        <li className="has-submenu" key={entry.label}>
                          <div className="mobile-nav-item-row">
                            <Link
                              href={entry.href}
                              className="has-children"
                              onClick={() => setMobileOpen(false)}
                            >
                              {entry.label}
                            </Link>
                            <button
                              type="button"
                              className={`mobile-nav-toggle${openNested === nestedKey ? " is-open" : ""}`}
                              aria-label={`${openNested === nestedKey ? "Collapse" : "Expand"} ${entry.label} submenu`}
                              aria-expanded={openNested === nestedKey}
                              onClick={() =>
                                setOpenNested((current) => (current === nestedKey ? null : nestedKey))
                              }
                            >
                              ⌄
                            </button>
                          </div>
                          <ul
                            className={`mobile-nav-submenu mobile-nav-submenu--nested${
                              openNested === nestedKey ? " is-open" : ""
                            }`}
                          >
                            {entry.items.map((link) => (
                              <li key={leafLabel(link)}>
                                <Link href={leafHref(link)} onClick={() => setMobileOpen(false)}>
                                  {leafLabel(link)}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      );
                    }
                    return (
                      <li key={leafLabel(entry)}>
                        <Link href={leafHref(entry)} onClick={() => setMobileOpen(false)}>
                          {leafLabel(entry)}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          ))}
        </nav>
 
        <Link href="/tellusyourproblem" className="header-cta mobile-nav-cta" onClick={() => setMobileOpen(false)}>
          Tell Us Your Problem <span>→</span>
        </Link>
      </div>
    </header>
  );
}